import { render, staticRenderFns } from "./setup-team.page.vue?vue&type=template&id=7aaaa83c&scoped=true&"
import script from "./setup-team.page.vue?vue&type=script&lang=js&"
export * from "./setup-team.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaaa83c",
  null
  
)

export default component.exports